import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Music2, Headphones } from "lucide-react";
import { CATEGORIES } from "../lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="text-[#050505] mt-24"
      style={{ background: "#0A8074" }}
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16">
        <div className="flex items-center gap-4 mb-10">
          <img
            src="/logo-bonsang.png"
            alt="Bon Sang"
            className="h-20 w-auto"
          />
          <span className="font-display-black text-4xl sm:text-5xl text-[#FFD01E]">
            BON SANG<span className="text-[#FA6157]">!</span>
          </span>
        </div>
        {/* huge email cta */}
        <a
          href="mailto:bonsangmagazine@gmail.com"
          data-testid="footer-email"
          className="block group"
        >
          <p className="text-[#FFD01E] uppercase text-xs font-bold tracking-widest mb-3">
            ÉCRIS-NOUS
          </p>
          <h2 className="font-display-black text-[#FFFDF7] group-hover:text-[#FFD01E] transition-colors whitespace-nowrap" style={{ fontSize: "clamp(1.5rem, 5.2vw, 4.5rem)" }}>
            bonsangmagazine@gmail.com
          </h2>
        </a>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 mt-16 border-t border-[#050505]/20 pt-12">
          <div>
            <p className="font-bold uppercase text-xs tracking-widest text-[#FFD01E] mb-4">Le mag</p>
            <ul className="space-y-2">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="hover:text-[#FFD01E] transition-colors text-sm text-[#FFFDF7]"
                    data-testid={`footer-cat-${c.slug}`}
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-bold uppercase text-xs tracking-widest text-[#FFD01E] mb-4">Le podcast</p>
            <ul className="space-y-2 text-sm text-[#FFFDF7]">
              <li>
                <a
                  href="https://open.spotify.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-spotify"
                  className="hover:text-[#FFD01E] flex items-center gap-2"
                >
                  <Music2 size={14} /> Spotify
                </a>
              </li>
              <li>
                <a
                  href="https://podcasts.apple.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-apple"
                  className="hover:text-[#FFD01E] flex items-center gap-2"
                >
                  <Headphones size={14} /> Apple Podcasts
                </a>
              </li>
              <li>
                <a
                  href="https://www.deezer.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-deezer"
                  className="hover:text-[#FFD01E] flex items-center gap-2"
                >
                  <Headphones size={14} /> Deezer
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-bold uppercase text-xs tracking-widest text-[#FFD01E] mb-4">Suis-nous</p>
            <ul className="space-y-2 text-sm text-[#FFFDF7]">
              <li>
                <a
                  href="https://instagram.com/bonsangmagazine"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="hover:text-[#FFD01E] flex items-center gap-2"
                >
                  <Instagram size={14} /> @bonsangmagazine
                </a>
              </li>
              <li>
                <a
                  href="https://tiktok.com/@bonsangmagazine"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-tiktok"
                  className="hover:text-[#FFD01E]"
                >
                  TikTok · @bonsangmagazine
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-bold uppercase text-xs tracking-widest text-[#FFD01E] mb-4">Légal</p>
            <ul className="space-y-2 text-sm text-[#FFFDF7]">
              <li>
                <Link to="/mentions-legales" data-testid="footer-legal" className="hover:text-[#FFD01E]">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/cookies" data-testid="footer-cookies" className="hover:text-[#FFD01E]">
                  Cookies
                </Link>
              </li>
              <li>
                <Link to="/admin" data-testid="footer-admin" className="hover:text-[#FFD01E]">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#050505]/20 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#FFFDF7]/70">
          <span>© {new Date().getFullYear()} Bon Sang Magazine — Tous droits réservés</span>
          <span>Fait avec sang, sueur & glitter 🩸</span>
        </div>
      </div>
    </footer>
  );
}
